/**
 * Service used for caching objects for a certain amount of time.
 */

/* @ngInject */
function cacheService ($window, CONSTANTS) {
  var api = {}

  api.setItem = setItem
  api.getItem = getItem
  api.removeItem = removeItem
  api.clearCache = clearCache

  return api

  /**
   *
   * @param {String} key
   * @param {Object} value
   * @param {Object} params
   * @param {number} params.hours how many hours to wait for expiration
   * @param {number} params.minutes how many minutes to wait for expiration
   */
  function setItem (key, value, params) {
    var now = new Date()

    if (params.hours) {
      now.setHours(now.getHours() + params.hours)
    }
    if (params.minutes) {
      now.setMinutes(now.getMinutes() + params.minutes)
    }

    $window.localStorage.setItem(key, JSON.stringify(value))
    $window.localStorage.setItem(key.concat(CONSTANTS.CACHE_EXPIRATION_SUFIX), JSON.stringify(now))

    var records = getRecords()
    if (records.indexOf(key) === -1) {
      addRecord(key)
    }
  }

  function getItem (key) {
    var now = new Date()

    var parsedDate = JSON.parse($window.localStorage.getItem(key.concat(CONSTANTS.CACHE_EXPIRATION_SUFIX)))
    var expirationDate = new Date(parsedDate)

    if (now >= expirationDate) {
      // deletes previous data
      $window.localStorage.removeItem(key)
      $window.localStorage.removeItem(key.concat(CONSTANTS.CACHE_EXPIRATION_SUFIX))
      return
    }
    return JSON.parse($window.localStorage.getItem(key))
  }

  function removeItem (key) {
    $window.localStorage.removeItem(key)
    $window.localStorage.removeItem(key.concat(CONSTANTS.CACHE_EXPIRATION_SUFIX))
  }

  function clearCache () {
    var records = getRecords()
    records.forEach(function (key) {
      $window.localStorage.removeItem(key)
      $window.localStorage.removeItem(key.concat(CONSTANTS.CACHE_EXPIRATION_SUFIX))
    })
  }

  function addRecord (key) {
    var records = $window.localStorage.getItem(CONSTANTS.CACHED_RECORDS)
    records = JSON.parse(records) || []
    records.push(key)
    $window.localStorage.setItem(CONSTANTS.CACHED_RECORDS, JSON.stringify(records))
  }

  function getRecords () {
    var records = $window.localStorage.getItem(CONSTANTS.CACHED_RECORDS)
    return JSON.parse(records) || []
  }
}

export { cacheService }
